export default __webpack_public_path__ + "static/hat-fa0dd0fe97a2e1bef1479010a6cbfb87.png";